import { TYPE_CLOSE, TYPE_SHOW } from './types';

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = [], { type, payload }) => {
  switch (type) {
    case TYPE_SHOW:
      return [payload, ...state];
    case TYPE_CLOSE:
      return payload.id
        ? state.filter((conf) => conf.id !== payload.id)
        : state.slice(1);
    default:
      return state;
  }
};
